import i18n from "i18n";
import FailureProcessingConfig from "./FailureProcessingConfig";
import FailureProcessingOverview from "./FailureProcessingOverview";
import streamFailureColumn from "./streamFailureColumn";
export default {
  systemConfigurations: [
    {
      component: FailureProcessingConfig,
      // Read lazily, so the name is translated when the configuration list renders and not when the module loads.
      get displayName() {
        return i18n.t("failure_config.title", { ns: "enterprise_data_tiering" });
      },
      configType: "org.graylog.plugins.failure.config.EnterpriseFailureHandlingConfiguration",
      permissions: "indices:failures"
    }
  ],
  systemOverview: [
    {
      component: FailureProcessingOverview
    }
  ],
  "components.streams.overview.tableElements": [streamFailureColumn]
};
